export const COWORKING = 1;
export const MEETING_ROOM = 2;
export const TERRACE = 3;

